import React from 'react';

import { useAccount } from '@hooks/useAccount';

import { BaseApprovalAlert } from './BaseApprovalAlert';

export const PendingApproval: React.FC = () => {
  const {
    account: {
      owner: { name }
    }
  } = useAccount();

  return (
    <BaseApprovalAlert
      heading='Waiting on Study approval'
      message={`Your account administrator, ${name}, must approve the study before you can send invites.`}
    />
  );
};
